//turn camelCase to space separated
export const capitalize = (str: string) => {
  return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase();
  });
};

// make 20220205 to 05-02-2022
export const formatDate = (str: string) => {
  return str.slice(4, 6) + "-" + str.slice(6, 8) + "-" + str.slice(0, 4);
};

// make 2022-02-05 to 05-02-2022
export const formatDate2 = (str: string) => {
  return str.slice(5, 7) + "-" + str.slice(8, 10) + "-" + str.slice(0, 4);
};
